import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export function getProductsCount(enabled) {
  return axios.get(`${API_URL}/products/count`, {
    params: {
      enabled,
    },
  });
}

export function getUsersCount() {
  return axios.get(`${API_URL}/users/count`);
}

export function getLastOrders() {
  return axios.get(`${API_URL}/orders`, {
    params: {
      pageNumber: 1,
      pageSize: 5,
    },
  });
}

export function getOrdersCount(countType) {
  return axios.get(`${API_URL}/orders/count`, {
    params: {
      countType,
    },
  });
}

export function getLatestInvoices() {
  return axios.get(`${API_URL}/Invoices`, {
    params: {
      pageNumber: 1,
      pageSize: 4,
    },
  });
}

export function getNotificationBadge(model){
  return axios.get(`${API_URL}/notifications`, {
    params: {
      model
    }
  })
}